// TODO: Move confirmation interfaces to this file
import { defineStore } from 'pinia';
import { computed, reactive } from 'vue';

export interface AdyenSession {
    sessionId: string | null;
    redirectResult: string | null;
}

export const useAdyenSessionStore = defineStore('adyen-session', () => {
    const store = reactive<AdyenSession>({
        sessionId: null,
        redirectResult: null
    });

    function setAdyenParameters(parameters: AdyenSession) {
        if (!parameters) {
            store.sessionId = null;
            store.redirectResult = null;
            return;
        }

        store.sessionId = parameters.sessionId;
        store.redirectResult = parameters.redirectResult;
    }

    function clearAdyenParameters() {
        store.sessionId = null;
        store.redirectResult = null;
    }

    return {
        adyenParameters: computed<AdyenSession>(() => store),
        setAdyenParameters,
        clearAdyenParameters
    };
});
